import { rem, modularScale as polishedModularScale } from 'polished'
import { scroller } from 'react-scroll'

export const pxToRem = (pxVal) => rem(pxVal, 18)

export const modularScale = (step) =>
  polishedModularScale(step, '1rem', 'minorThird')

export const scrollIntoView = (name) => {
  scroller.scrollTo(name, {
    duration: 800,
    delay: 0,
    smooth: 'easeInOutQuart',
    offset: -175,
  })
}

export const initializeArrayWithRange = (end, start = 0) =>
  Array.from({ length: end + 1 - start }).map((v, i) => i + start)
